// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"504":"7a44d3df","516":"66610750"}[chunkId] + ".chunk.css";
};